// extracted by mini-css-extract-plugin
export var carouselContainer = "w_qt d_s d_D d_bb d_W";
export var carouselContainerCards = "w_sw w_qt d_s d_D d_bb d_W";
export var carouselContainerSides = "w_sx d_s d_D d_W";
export var prevCarouselItem = "w_sy d_s d_D d_X d_g";
export var prevCarouselItemL = "w_sz w_sy d_s d_D d_X d_g";
export var moveInFromLeft = "w_sB";
export var prevCarouselItemR = "w_sC w_sy d_s d_D d_X d_g";
export var moveInFromRight = "w_sD";
export var selectedCarouselItem = "w_sF d_s d_D d_W d_bb";
export var selectedCarouselItemL = "w_sG w_sF d_s d_D d_W d_bb";
export var selectedCarouselItemR = "w_sH w_sF d_s d_D d_W d_bb";
export var nextCarouselItem = "w_sJ d_s d_D d_X d_g";
export var nextCarouselItemL = "w_sK w_sJ d_s d_D d_X d_g";
export var nextCarouselItemR = "w_sL w_sJ d_s d_D d_X d_g";
export var arrowContainer = "w_sM d_D d_X d_dx d_bh d_1 d_bY";
export var prevArrowContainer = "w_sN w_sM d_D d_X d_dx d_bh d_1 d_bY";
export var prevArrowContainerHidden = "w_sP w_sN w_sM d_D d_X d_dx d_bh d_1 d_bY d_g";
export var nextArrowContainer = "w_sQ w_sM d_D d_X d_dx d_bh d_1 d_bY";
export var carouselContainerProducts = "w_sR";
export var nextArrowContainerHidden = "w_sS w_sQ w_sM d_D d_X d_dx d_bh d_1 d_bY d_g";
export var arrow = "w_kK d_X";
export var prevArrow = "w_sT w_kK d_X";
export var nextArrow = "w_sV w_kK d_X";
export var carouselIndicatorContainer = "w_sW d_s d_ds d_bh d_bw d_bz d_bL d_bF d_X";
export var btnsContainer = "w_sX d_s d_bw d_bB";
export var carouselText = "w_sY d_dm d_bw d_bz d_bL d_bY d_dx d_cz";
export var carouselTextInactive = "w_sZ w_sY d_dm d_bw d_bz d_bL d_bY d_dx d_cz";
export var indicator = "w_s0 d_b4";
export var carouselIndicator = "w_s1 w_s0 d_b4";
export var carouselIndicatorSelected = "w_s2 w_s0 d_b4";
export var arrowsContainerTopRight = "w_s3 d_X d_bh d_by";
export var arrowsContainerBottomLeft = "w_s4 d_X d_bh d_by";
export var arrowsContainerSides = "w_s5 d_X d_bh d_by";
export var smallArrowsBase = "w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainer = "w_s7 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerPrev = "w_s8 w_s7 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerSmall = "w_s9 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerPrevSmall = "w_tb w_s9 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var icon = "w_p0";
export var iconSmall = "w_tc";
export var multipleWrapper = "w_td d_by d_bB d_bb";
export var multipleImage = "w_tf d_by";
export var sidesPrevContainer = "w_tg w_s7 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz d_fk d_X d_bh d_cz";
export var sidesNextContainer = "w_th w_s7 w_s6 d_bQ d_bw d_bz d_bL d_bY d_dx d_cz d_fk d_X d_bh d_cz";